import { EditOffHireSummaryCommand } from './edit-off-hire-summary-command';
import { EditOffHireCommand } from './edit-off-hire-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class MarkOffHireSummaryCompleteCommand {
  EditOffHireSummaryCommand: EditOffHireSummaryCommand;
  EditOffHireCommand: EditOffHireCommand;
  OffHireId: string;
  When: string;
  OffsetFromUtc: number;
  SubmittedOn: string;
}


